const config = {
  bucketName: 'cyberdogz-users',
  region: 'us-west-1',
  dirName:"users",
  accessKeyId: "AKIAVLXCYP7B7NIIB6ES",
  secretAccessKey:"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",
}
export default config;
